export default {
	field: 'part.partClass.description',
	name: 'Description',
}
